import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { BackgroundJobsService } from '~src/backgroundJob/types/BackgroundJobs';
import { Messages } from '~src/codegen/Localize';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { BackgroundJobContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getBackgroundJobsDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const BackgroundJobDefinition: ExplorableItemDefinition = {
  itemType: 'backgroundJob',
  pluralName: Messages.backgroundJobs,
  singularName: Messages.backgroundJob,
  emptyStateMessage: Messages.backgroundJobsEmptyMessage,
  contentFilterKeys: [
    ContentFiltersKeys.backgroundJobStatus,
    ContentFiltersKeys.backgroundJobTaskType,
    ContentFiltersKeys.backgroundJobTimeRange,
    ContentFiltersKeys.showSystemJobs,
  ],
  defaultFilters: getBackgroundJobsDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['backgroundJob']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return BackgroundJobsService.all().withExtraParams(BackgroundJobContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
